// components/IncidentPublic.js
// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import {
//   Container,
//   Paper,
//   Typography,
//   Box,
//   Chip,
//   Grid,
//   Card,
//   CardMedia,
//   CircularProgress,
//   Alert,
//   Divider,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import COLORS from './colors';
// import userService from '../services/userService';

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   marginTop: theme.spacing(4),
//   marginBottom: theme.spacing(4),
//   borderRadius: 16,
//   boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
// }));

// const IncidentImage = styled(CardMedia)({
//   height: 200,
//   borderRadius: 8,
//   objectFit: 'cover',
// });

// const IncidentPublic = () => {
//   const { token } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [incident, setIncident] = useState(null);

//   useEffect(() => {
//     const fetchIncident = async () => {
//       try {
//         const response = await userService.getIncidentPublic(token);
        
//         if (response.status !== 200) {
//           throw new Error('Incident not found or link expired');
//         }
        
//         setIncident(response.data);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     if (token) {
//       fetchIncident();
//     }
//   }, [token]);

//   if (loading) {
//     return (
//       <Container maxWidth="md">
//         <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
//           <CircularProgress />
//         </Box>
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md">
//         <Box mt={8}>
//           <Alert severity="error">{error}</Alert>
//         </Box>
//       </Container>
//     );
//   }

//   if (!incident) {
//     return (
//       <Container maxWidth="md">
//         <Box mt={8}>
//           <Alert severity="warning">No incident data found</Alert>
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="md">
//       <StyledPaper elevation={0}>
//         {/* Header */}
//         <Box mb={3}>
//           <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
//             🚨 Incident at {incident.property_name}
//           </Typography>
//           <Chip
//             label={incident.status || 'reported'}
//             color={incident.status === 'resolved' ? 'success' : 'warning'}
//             size="small"
//           />
//         </Box>

//         <Divider sx={{ mb: 3 }} />

//         {/* Details */}
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="subtitle2" color="textSecondary">
//               Reported at
//             </Typography>
//             <Typography variant="body1" gutterBottom>
//               {incident.reported_at}
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="subtitle2" color="textSecondary">
//               Status
//             </Typography>
//             <Typography variant="body1" gutterBottom textTransform="capitalize">
//               {incident.status}
//             </Typography>
//           </Grid>
//         </Grid>

//         {/* Description */}
//         <Box mt={3} mb={3}>
//           <Typography variant="subtitle2" color="textSecondary">
//             Description
//           </Typography>
//           <Paper
//             variant="outlined"
//             sx={{ p: 2, bgcolor: '#f8fafc', borderLeft: `4px solid ${COLORS.primary}` }}
//           >
//             <Typography variant="body1" whiteSpace="pre-wrap">
//               {incident.description}
//             </Typography>
//           </Paper>
//         </Box>

//         {/* Photos */}
//         {incident.photos && incident.photos.length > 0 && (
//           <Box mt={3}>
//             <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//               Attached Photos
//             </Typography>
//             <Grid container spacing={2}>
//               {incident.photos.map((photo, index) => (
//                 <Grid item xs={6} sm={4} key={index}>
//                   <Card elevation={1}>
//                     <IncidentImage
//                       component="img"
//                       image={photo.url || photo}
//                       alt={`Incident photo ${index + 1}`}
//                     />
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>
//         )}

//         <Box mt={4} textAlign="center">
//           <Typography variant="caption" color="textSecondary">
//             This is a public incident report from FreshSweeper.
//           </Typography>
//         </Box>
//       </StyledPaper>
//     </Container>
//   );
// };

// export default IncidentPublic;


import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Chip,
  Grid,
  Card,
  CardMedia,
  CircularProgress,
  Alert,
  Divider,
  TextField,
  Button,
  Snackbar,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import COLORS from './colors';
import userService from '../services/userService';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
}));

const IncidentImage = styled(CardMedia)({
  height: 200,
  borderRadius: 8,
  objectFit: 'cover',
});

const ReplyBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(3),
  backgroundColor: '#f8fafc',
  borderRadius: 12,
  border: '1px solid #e2e8f0',
}));

const IncidentPublic = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [incident, setIncident] = useState(null);
  
  // Reply state
  const [replyMessage, setReplyMessage] = useState('');
  const [replyName, setReplyName] = useState('');
  const [replyEmail, setReplyEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [replySuccess, setReplySuccess] = useState(false);
  const [replyError, setReplyError] = useState(null);

  useEffect(() => {
    const fetchIncident = async () => {
      try {
        const response = await userService.getIncidentPublic(token);
        if (response.status !== 200) {
          throw new Error('Incident not found or link expired');
        }
        setIncident(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchIncident();
    }
  }, [token]);

  const handleSendReply = async () => {
    if (!replyMessage.trim()) {
      setReplyError('Please enter a message');
      return;
    }

    setSending(true);
    setReplyError(null);

    try {
      const payload = {
        token,
        message: replyMessage.trim(),
        name: replyName.trim() || 'Team Member',
        email: replyEmail.trim() || undefined,
      };
      await userService.sendIncidentReply(payload);
      setReplySuccess(true);
      setReplyMessage('');
      setReplyName('');
      setReplyEmail('');
    } catch (err) {
      setReplyError(err.response?.data?.message || 'Failed to send reply. Please try again.');
    } finally {
      setSending(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="md">
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Box mt={8}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </Container>
    );
  }

  if (!incident) {
    return (
      <Container maxWidth="md">
        <Box mt={8}>
          <Alert severity="warning">No incident data found</Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <StyledPaper elevation={0}>
        {/* Header */}
        <Box mb={3}>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            🚨 Incident at {incident.property_name}
          </Typography>
          <Chip
            label={incident.status || 'reported'}
            color={incident.status === 'resolved' ? 'success' : 'warning'}
            size="small"
          />
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Details Grid */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Reported at
            </Typography>
            <Typography variant="body1" gutterBottom>
              {incident.reported_at}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Status
            </Typography>
            <Typography variant="body1" gutterBottom textTransform="capitalize">
              {incident.status}
            </Typography>
          </Grid>
          {/* 👇 Address field */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Property Address
            </Typography>
            <Typography variant="body1" gutterBottom>
              {incident.address || 'N/A'}
            </Typography>
          </Grid>
        </Grid>

        {/* Description */}
        <Box mt={3} mb={3}>
          <Typography variant="subtitle2" color="textSecondary">
            Description
          </Typography>
          <Paper
            variant="outlined"
            sx={{ p: 2, bgcolor: '#f8fafc', borderLeft: `4px solid ${COLORS.primary}` }}
          >
            <Typography variant="body1" whiteSpace="pre-wrap">
              {incident.description}
            </Typography>
          </Paper>
        </Box>

        {/* Photos */}
        {incident.photos && incident.photos.length > 0 && (
          <Box mt={3}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Attached Photos
            </Typography>
            <Grid container spacing={2}>
              {incident.photos.map((photo, index) => (
                <Grid item xs={6} sm={4} key={index}>
                  <Card elevation={1}>
                    <IncidentImage
                      component="img"
                      image={photo.url || photo}
                      alt={`Incident photo ${index + 1}`}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}

        {/* Reply Section */}
        <ReplyBox>
          <Typography variant="h6" gutterBottom>
            💬 Respond to this incident
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            Your reply will be sent to the property host.
          </Typography>

          <TextField
            fullWidth
            label="Your message *"
            multiline
            rows={3}
            value={replyMessage}
            onChange={(e) => setReplyMessage(e.target.value)}
            variant="outlined"
            margin="normal"
            required
            disabled={sending}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Your name"
                value={replyName}
                onChange={(e) => setReplyName(e.target.value)}
                variant="outlined"
                margin="normal"
                disabled={sending}
                placeholder="e.g. John Smith"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Your email (optional)"
                value={replyEmail}
                onChange={(e) => setReplyEmail(e.target.value)}
                variant="outlined"
                margin="normal"
                disabled={sending}
                placeholder="e.g. john@example.com"
              />
            </Grid>
          </Grid>

          {replyError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {replyError}
            </Alert>
          )}

          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendReply}
              disabled={sending || !replyMessage.trim()}
            >
              {sending ? 'Sending...' : 'Send Reply'}
            </Button>
          </Box>
        </ReplyBox>

        <Box mt={4} textAlign="center">
          <Typography variant="caption" color="textSecondary">
            This is a public incident report from FreshSweeper.
          </Typography>
        </Box>
      </StyledPaper>

      {/* Success Snackbar */}
      <Snackbar
        open={replySuccess}
        autoHideDuration={6000}
        onClose={() => setReplySuccess(false)}
        message="✅ Your reply has been sent to the host."
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Container>
  );
};

export default IncidentPublic;